var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_Caret"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Caret",
    clipPath: "url(#clip-Icon_Caret)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_12",
    "data-name": "Polygon 12",
    d: "M7.622,3.091a3,3,0,0,1,4.756,0l3.907,5.08A3,3,0,0,1,13.907,13H6.093A3,3,0,0,1,3.715,8.171Z",
    transform: "translate(17) rotate(90)",
    fill: "#dbe1e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaret);
export default __webpack_public_path__ + "static/media/Icon_Caret.fbfa61d8e076d21bd9a0090fc943c7ae.svg";
export { ForwardRef as ReactComponent };